import type { FormTarget } from "@jti/magento";

export const FAST_FLOW_ORDER_ATTRIBUTE_PLACEMENTS: FormTarget[] = [
  "contactDetails_before",
  "contactDetails_after",
  "shippingAddress_before",
  "shippingAddress_after",
  "billingaddress_before",
  "billingaddress_after",
  "buttonPlaceOrder_before",
];
